// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__RoZwj","logo":"styles_logo__HfHwW"};